import { useDispatch } from 'react-redux';
import { setRankingThresholds, setRankingLoading } from 'src/stateManagement/reducers/maps/MapRepairPlan';
import { useMinMaxRating } from './useMinMaxRating';
import { useEffect, useMemo } from 'react';

export function useRankingThresholds({ filter, enabled }: { filter?: string, enabled?: boolean }) {
  const dispatch = useDispatch();
  const { min, max, isLoading } = useMinMaxRating({ filter, enabled });

  const { lowT, highT } = useMemo(() => {
    if (min != null && max != null) {
      const dif = max - min;
      const low  = Math.ceil(min + dif / 3);
      const high = Math.ceil(max - dif / 3);
      if (high > low) return { lowT: low, highT: high };
    }
    return { lowT: null as number | null, highT: null as number | null };
  }, [min, max]);

  useEffect(() => {
    dispatch(setRankingLoading(Boolean(enabled) && isLoading));

    if (!enabled || isLoading || lowT == null || highT == null) {
      dispatch(setRankingThresholds(null));
      return;
    }
    dispatch(setRankingThresholds({ low: lowT, high: highT }));
  }, [enabled, isLoading, lowT, highT]);

  useEffect(() => () => {
    dispatch(setRankingLoading(false));
  }, [dispatch]);

  return { lowT, highT, isLoading };
}